import Vue from 'vue'
import Vuex from 'vuex'

import { Loading,  QSpinnerFacebook,  } from 'quasar'
import { Notify } from 'quasar'



Vue.use(Vuex);

// const URL_APP = 'http://localhost:6001/';
const URL_APP = 'https://server-survei.disdukcapil.konaweselatankab.go.id/';


export default new Vuex.Store({
  state: {
    coordinat : {
      lat:-4.034694, 
      lng: 122.484263
    },
    btn : {
      add : false,
      edit : false,
      remove : false,
    },
    url : {
      URL_APP : URL_APP,
      URL_masterKuesioner : URL_APP+'api/v1/masterKuesioner/',
      URL_masterKuesionerEvaluasi : URL_APP+'api/v1/masterKuesionerEvaluasi/',
      URL_kuesioner : URL_APP+'api/v1/kuesioner/',

      URL_LPSE_validasi : URL_APP+'api/v1/LPSE_validasi/',
    
    },



    unit_kerja : '',
    level_user : 2,

    page_first: 1,
    page_last: 0,
    cari_value: "",
    cek_load_data : true,


    tahun : [2020,2021,2022,2023,2024],

    tahunSemester : {
      tahun : '',
      semester : ''
    }

    
  },
  mutations: {

    getStorage(state){


      var get_profile = JSON.parse(localStorage.profile);
      state.level_user = get_profile.profile.level; 


      // level_user
    },
    shoWLoading(){
      const spinner = typeof QSpinnerFacebook !== 'undefined'
        ? QSpinnerFacebook // Non-UMD, imported above
        : Quasar.components.QSpinnerFacebook // eslint-disable-line


      Loading.show({
        spinner,
        spinnerColor: 'yellow',
        spinnerSize: 140,
        backgroundColor: 'purple',
        // message: 'Loading... Tunggu beberapa saat, system sedang menyesuaikan akun anda..!',
        // messageColor: 'white'
      })
    },
    hideLoading(){
      Loading.hide()
    },
    shoWNotify(state, message, color, icon){
      Notify.create({
        message: message,
        color: color,
        position : 'top-right',
        icon:icon
      })
    },
  },
  actions: {
  },
  modules: {
  }
})
